import * as actionTypes from "../../actionLabels/index";

export const fetchAuctionSearchBidBookData = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_SEARCH_BID_BOOK_DATA,
    payload: data,
  };
};

export const fetchAuctionSearchBidBookDataSuccess = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_SEARCH_BID_BOOK_DATA_SUCCESS,
    payload: data,
  };
};

export const fetchAuctionSearchBidBookDataFailure = (error) => {
  return {
    type: actionTypes.FETCH_AUCTION_SEARCH_BID_BOOK_DATA_FAILURE,
    payload: error,
  };
};

export const fetchAuctionSearchBidBookDataExportSuccess = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_SEARCH_BID_BOOK_DATA_EXPORT_SUCCESS,
    payload: data,
  };
};

export const fetchAuctionSearchBidBookDataApiCall = (data) => {
  return {
    type: actionTypes.FETCH_AUCTION_SEARCH_BID_BOOK_DATA_API_CALL,
    payload: data,
  };
};

export const fetchSessionTimeForBidBook = (data) => {
  return {
    type: actionTypes.FETCH_SESSION_TIME_FOR_BID_BOOK,
    payload: data,
  };
};

export const fetchSessionTimeForBidBookSuccess = (data) => {
  return {
    type: actionTypes.FETCH_SESSION_TIME_FOR_BID_BOOK_SUCCESS,
    payload: data,
  };
};

export const fetchSessionTimeForBidBookFailure = (data) => {
  return {
    type: actionTypes.FETCH_SESSION_TIME_FOR_BID_BOOK_FAILURE,
    payload: data,
  };
};

export const fetchLotNumberBySessionDetailId = (data) => {
  return {
    type: actionTypes.FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID,
    payload: data,
  };
};

export const fetchLotNumberBySessionDetailIdSuccess = (data) => {
  return {
    type: actionTypes.FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID_SUCCESS,
    payload: data,
  };
};

export const fetchLotNumberBySessionDetailIdFailure = (data) => {
  return {
    type: actionTypes.FETCH_LOT_NUMBER_BY_SESSION_DETAIL_ID_FAILURE,
    payload: data,
  };
};
